import React from "react";
import EventTable from "../components/EventTable";
import TASignalMonitor from "../components/TASignalMonitor";
import AlpacaDashboard from "../components/AlpacaDashboard";
import DatabaseDashboard from "../components/DatabaseDashboard";

export default function Dashboard() {
  return (
    <div className="p-4 sm:p-6 space-y-6 sm:space-y-8 bg-gray-900 min-h-screen">
      <h1 className="text-2xl sm:text-3xl font-bold text-white mb-6 sm:mb-8">📊 Trading Dashboard</h1>

      {/* Local Database */}
      <DatabaseDashboard />

      {/* Alpaca Trading Account */}
      <AlpacaDashboard />

      {/* TA Buy/Sell Signals - sends to Telegram */}
      <TASignalMonitor watchlist={["BTC/USDT", "ETH/USDT", "SOL/USDT", "MSTR"]} />

      {/* Bollinger Band Events */}
      <EventTable
        collectionName="BBEvents"
        title="Bollinger Band Signals"
      />

      {/* Fear & Greed Events */}
      <EventTable
        collectionName="FearGreedEvents"
        title="Fear & Greed Index"
      />
    </div>
  );
}
